import React, { lazy, Suspense, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Redirect, Route, useHistory } from "react-router-dom";
import { userActions } from "../actions";

import MemberGroupLayout from "./MemberGroupLayout";

export const routes = [
    {
        path: "/membergroup/logon",
        exact: true,
        component: lazy(() => import("../pages/MemLogin/Memlogin")),
    },

    {
        path: "/membergroup/dashboard",
        exact: true,
        auth: true,
        layout: "membergroup",
        component: lazy(() => import("../pages/dashboardPage/Dashboard")),
    },

    {
        path: "/membergroup/keeprep",
        exact: true,
        auth: true,
        layout: "membergroup",
        component: lazy(() => import("../pages/keepRepPage/KeepRepPage")),
    },
    {
        path: "/membergroup/delivery_book",
        exact: true,
        auth: true,
        layout: "membergroup",
        component: lazy(() => import("../pages/Keepbook/Delivery_book")),
    },
    {
        path: "/membergroup/summarize_rep",
        exact: true,
        auth: true,
        layout: "membergroup",
        component: lazy(() => import("../pages/KeepSum/Summarize_rep")),
    },
    {
        path: "/membergroup/password",
        exact: true,
        auth: true,
        layout: "membergroup",
        component: lazy(() => import("../pages/MemPass/Mempass")),
    },
    {
        path: "/membergroup/guide_group",
        exact: true,
        auth: true,
        layout: "membergroup",
        component: lazy(() => import("../pages/KeepGuide/Guide_group")),
    },
    // {
    //     path: "/membergroup/forget",
    //     exact: true,
    //     // component: lazy(() => import("../pages/Memregis/Memregis"))
    //     component: lazy(() => import("../pages/Memregis/UserAuthMain"))
    // },
    // {
    //     path: "/membergroup/impersonate",
    //     exact: true,
    //     component: lazy(() => import("../pages/MemImpersonate/MemInpersonate"))
    // },
];

const MemberGroupRoute = ({ component: Component, ...rest }) => {
    const isAuthMemGroup = useSelector((state) => state.authmemgroup.loggedIn);

    const dispatch = useDispatch();
    const history = useHistory();

    useEffect(() => {
        if (isAuthMemGroup) {
            dispatch(userActions.getAuthUser()).catch(() => {
                // NotificationManager.error(err.data.error, "Error", 5000);
                history.push("/membergroup/logon");
            });
        }
    }, [dispatch, isAuthMemGroup]);

    return (
        <Route
            {...rest}
            render={(props) => {
                if (!isAuthMemGroup)
                    return <Redirect to="/membergroup/logon" />;

                return (
                    <Suspense fallback={<> </>}>
                        {/* <ScrollToTop /> */}
                        <MemberGroupLayout>
                            <Component {...props} />
                        </MemberGroupLayout>
                    </Suspense>
                );
            }}
        />
    );
};

export default MemberGroupRoute;
